<template>
    <div>
        <!-- Sized to ISO/IEC 7810 ID-1 (credit card) aspect ratio, 85.6 x 53.98 mm -->
        <v-card
        class="d-flex align-center"
        style="width: 1012px !important; height: 638px !important; overflow: hidden; padding: 32px">
            <!-- QR takes the full height of the card so it prints large enough to scan -->
            <div class="d-flex align-center justify-center" style="flex: 0 0 auto">
                <v-card-text class="text-center pa-0 ma-0" id="downloadCode">
                    <qrcode-vue
                        :value="user.id"
                        size="480"
                        level="M"
                        id="qrcode"
                        renderAs="canvas"
                        background="#ffffff"
                        foreground="#000000">
                    </qrcode-vue>
                </v-card-text>
            </div>
            <!-- Text sits level with the top of the QR, logo level with its bottom -->
            <div class="d-flex flex-column justify-space-between" style="flex: 1 1 auto; min-width: 0; height: 480px; padding-left: 32px; overflow: hidden">
                <div class="font-weight-bold d-flex flex-column text-h4">
                    <div>Name: <span class="font-weight-normal">{{ user.userName }}</span></div>
                    <div class="pt-4">Job Title: <span class="font-weight-normal">{{ user.userJobTitle }}</span></div>
                </div>
                <!-- max-width keeps the logo inside the text column rather than overflowing the card -->
                <v-img :src="require('@/assets/tfw_logo_light.png')" contain height="90" max-width="100%" style="flex: 0 0 auto" position="left bottom"/>
            </div>
        </v-card>
    </div>
</template>

<script>
    import QrcodeVue from "qrcode.vue";
    export default {
        name: 'QRCard',
        components: {
            QrcodeVue
        },
        props: {
            user: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style>

</style>
